import "../../js/helper/Helper.User.js";

const HelperUserObject: typeof HelperUser = window.Helper.User;

export {HelperUserObject as HelperUser};